import { Time } from "@angular/common";

export class DateTimeUtil {

  constructor() {
  }

  converterDateParaTime(date: Date): Time {
    return {
      hours: date.getHours(),
      minutes: date.getMinutes()
    };
  }

  converterSegundosParaDate(seconds: number): Date {
      const d = new Date(0, 0, 0, 0, 0, 0, 0);
      d.setSeconds(seconds);
      return d;
  }

  getPrimeiroDiaDoMes(): Date {
    const date = new Date();
    const primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
    return primeiroDia;
  }

  getUltimoDiaDoMes(): Date {
    const date = new Date();
    const ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return ultimoDia;
  }

  timeToString(time: Time, incluirSegundos?: true): string {
    let str = '';

    if ( time ) {
      const hora     = time.hours;
      const minuto   = time.minutes;

      str += (( hora >= 0 && hora < 10 ) ? '0' : '' ) + hora;
      str += ':';
      str += (( minuto >= 0 && minuto < 10 ) ? '0' : '' ) + minuto;

      if ( incluirSegundos ) {
        str += ':00';
      }
    }

    return str;
  }

  static stringToTime(time: string | Time): Time {
    try {
      if ( time ) {
        let hora = Number.parseInt((time + '').split(':')[0]);
        let minuto = Number.parseInt((time + '').split(':')[1]);

        return {
          hours: hora,
          minutes: minuto
        }
      }
    }
    catch(e) {
      console.error('date-time.util.ts', e);
    }

    return null;
  }

  dateToIsoFormat(date: Date): string {
    if ( date ) {
      const _date: Date = this.isString(date) ? new Date(date) : date;
      return _date.toISOString().split('T')[0];
    }

    return null;
  }

  dateTimeToIsoFormat(date: Date, incluirSegundos?: true): string {
    if ( date ) {
      const _date: Date = this.isString(date) ? new Date(date) : date;
      const o = this.dateToIsoFormat(_date) + ' ' + this.timeToString( this.converterDateParaTime(_date), incluirSegundos );

      return o;
    }

    return null;
  }

  public validarDataFormatoBr(date: string): boolean {
    if ( !date ) {
      return false
    }

    let dateformat = /^(0?[1-9]|[1-2][0-9]|3[01])[\/](0?[1-9]|1[0-2])/; // DD/MM/YYYY
    let dateFormatCaracteres = /^\d{2}\/\d{2}\/\d{4}$/; // xx/xx/xxxx

    // Matching the date through regular expression
    if (date.match(dateFormatCaracteres) &&  date.match(dateformat)) {
        let operator = date.split('/');

        // Extract the string into month, date and year
        let datepart = [];
        if (operator.length > 1) {
            datepart = date.split('/');
        }
        let day = parseInt(datepart[0]);
        let month = parseInt(datepart[1]);
        let year = parseInt(datepart[2]);

        // Create a list of days of a month
        let ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month == 1 || month > 2) {
          if (day > ListofDays[month - 1]) {
            //to check if the date is out of range
            return false;
          }
        } else if (month == 2) {
            let leapYear = false;
            if ((!(year % 4) && year % 100) || !(year % 400)) leapYear = true;
            if ((leapYear == false) && (day >= 29)) {
              return false;
            }
            else {
              if ((leapYear == true) && (day > 29)) {
                return false;
              }
            }
        }
    } else {
        return false;
    }

    return true;
  }

  public stringBrToDate(ddmmyyyy: string): Date {
    if ( !this.validarDataFormatoBr(ddmmyyyy) ) {
      return null;
    }

    const separador = (ddmmyyyy.indexOf('-') > 0 ? '-' : '/');

    var parts = ddmmyyyy.split(separador);
    const dia = parseInt(parts[0]);
    const mes = parseInt(parts[1]) - 1;
    const ano = parseInt(parts[2]);

    return new Date(ano, mes, dia);
  }

  public stringIsoToDate(yyyymmdd: string): Date {
    return DateTimeUtil.stringIsoToDate(yyyymmdd);
  }

  public static stringIsoToDate(yyyymmdd: string): Date {
    if ( !yyyymmdd || !yyyymmdd.trim() ) {
      return null;
    }

    const dataIso = yyyymmdd.trim();
    const dataIsoMatch = /^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/.exec(dataIso);

    if ( !dataIsoMatch ) {
      return null;
    }

    var parts = dataIsoMatch.slice(1);
    const ano = parseInt(parts[0]);
    const mes = parseInt(parts[1]) - 1;
    const dia = parseInt(parts[2]);
    const data = new Date(ano, mes, dia);

    if ( data.getFullYear() !== ano || data.getMonth() !== mes || data.getDate() !== dia ) {
      return null;
    }

    return data;
  }

  private isString(o: string | Date): boolean {
    return (typeof o === 'string' || o instanceof String);
  }

  dateToDiaMesAno(date: Date): string {
    let _date = null;

    if ( this.isString(date) ) {
      _date = this.stringIsoToDate('' + date);
    }
    else {
      _date = new Date(date);
    }

    const dia = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate();
    const mes = (_date.getMonth() + 1) < 10 ? '0' + (_date.getMonth() + 1) : (_date.getMonth() + 1);

    return `${dia}/${mes}/${_date.getFullYear()}`;
  }

  isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
           someDate.getMonth() == today.getMonth() &&
           someDate.getFullYear() == today.getFullYear();
  }

  /**
   *
   * @param date
   * @returns dd/MM/yyyy HH:mm:ss
   */
  dateToDiaMesAnoETempo(date: Date): string {
    let _date = null;

    if ( this.isString(date) ) {
      _date = this.stringIsoToDate('' + date);
    }
    else {
      _date = new Date(date);
    }

    const dia      = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate();
    const mes      = (_date.getMonth() + 1) < 10 ? '0' + (_date.getMonth() + 1) : (_date.getMonth() + 1);

    const hora     = _date.getHours() < 10 ? '0' + _date.getHours() : _date.getHours();
    const minuto   = _date.getMinutes() < 10 ? '0' + _date.getMinutes() : _date.getMinutes();
    const segundo  = _date.getSeconds() < 10 ? '0' + _date.getSeconds() : _date.getSeconds();

    return `${dia}/${mes}/${_date.getFullYear()} ${hora}:${minuto}:${segundo}`;
  }

  tempoPorExtenso(tempoMs: number): string {
    var sec_num = Math.floor(tempoMs / 1000); // don't forget the second param
    var days    = Math.floor(sec_num / 86400);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    const minuteLabel = 'm';
    const hourLabel = 'h';

    if ( days > 0 ) {
      // Fix 02/04/2019
      hours=hours-(24 * days);
      return days + ' D ' + hours + ' ' + hourLabel + ' ' + minutes + ' ' + minuteLabel + ' ' + seconds + ' s';
    }
    else if ( hours > 0 ) {
      return hours + ' ' + hourLabel + ' ' + minutes + ' ' + minuteLabel + ' ' + seconds + ' s';
    }
    else if ( minutes > 0 ) {
      return minutes + ' ' + minuteLabel + ' ' + ( seconds > 0 ? (seconds + ' s') : '');
    }
    else if ( seconds > 0 ) {
      return seconds + ' s';
    }
    else if ( seconds == 0 ) {
      return tempoMs + ' ms';
    }
    else {
      return days+' D '+hours+' ' + hourLabel + ' '+minutes+' ' + minuteLabel + ' '+seconds + ' s';
    }
  }

  static compararTimes(timeA: Time, timeB: Time): number {
    try {
      const dateA = new Date('2000-01-01');
      dateA.setHours(timeA.hours);
      dateA.setMinutes(timeA.minutes);

      const dateB = new Date('2000-01-01');
      dateB.setHours(timeB.hours);
      dateB.setMinutes(timeB.minutes);

      if ( dateA.getTime() === dateB.getTime() ) {
        // igual
        return 0;
      }
      else if ( dateA.getTime() > dateB.getTime() ) {
        // dateA eh mais recente que dateB
        return 1;
      }
      else {
        // dateA eh mais antiga que dateB
        return -1;
      }

    }
    catch (e) {
      return 0;
    }
  }

  compararMesmoDia(data1: Date, data2: Date): boolean {
    if ( data1 && data1 instanceof Date &&
         data2 && data2 instanceof Date ) {
      return (
        data1.getFullYear() === data2.getFullYear() &&
        data1.getMonth()    === data2.getMonth() &&
        data1.getDate()     === data2.getDate()
      );
    }

    return false;
  }

  calcularDiferencaEmMinutos(data1: Date, data2: Date): number {
    if ( !data1 || !data2 ) {
      return null;
    }

    const diffMs = Math.abs(data2.getTime() - data1.getTime());
    const diffMin = Math.floor(diffMs / 60000); // 1 minuto = 60000 milissegundos

    return diffMin;
  }


  converterQuantidadeDeDiasEmAnoMesEDiasPorExtenso(dias): string {
    var anos = Math.floor(dias / 365); // Calcula a quantidade de anos completos
    var meses = Math.floor((dias % 365) / 30); // Calcula a quantidade de meses completos
    var diasRestantes = dias % 365 % 30; // Calcula a quantidade de dias restantes

    var bissextos = Math.floor(anos / 4); // Calcula a quantidade de anos bissextos

    var diasDoAno = diasRestantes + (bissextos * 366) + ((anos - bissextos) * 365); // Considera os dias dos anos bissextos

    var resultado = "";

    if (anos > 0) {
      resultado += anos + (anos === 1 ? " ano" : " anos");
    }

    if (meses > 0) {
      resultado += (anos > 0 ? ", " : "") + meses + (meses === 1 ? " mês" : " meses");
    }

    if (diasDoAno > 0) {
      if (anos > 0 || meses > 0) {
        resultado += ", ";
      }

      if (diasDoAno === 1) {
        resultado += "1 dia";
      } else {
        if (meses > 0) {
          resultado += "e ";
        }

        resultado += diasRestantes + (diasRestantes === 1 ? " dia" : " dias");
      }
    }

    if ( resultado ) {
      resultado = resultado.replace(', e', ' e');
    }

    return resultado;
  }

}
